
import store from "../store";
import * as types from "./constants";
import * as utils from "../utils";

export function createWhatToBring(data) {
  const url = `/ajax/event/${window.evite_event.id}/what-to-bring/?gid=${window.guest_id}`;
  window.$.post(url, data, (response) => {
    store.dispatch({
      type: types.UPDATE_WHAT_TO_BRING,
      whatToBring: response
    });
  })
  .fail(function(jqXHR, textStatus, errorThrown) {
    utils.renderAjaxErrorModal(jqXHR, textStatus, errorThrown);
  });
}

export function updateWhatToBring(data) {
  const url = `/ajax/event/${window.evite_event.id}/what-to-bring/update-items/?gid=${window.guest_id}`;
  window.$.post(url, data, (response) => {
    store.dispatch({
      type: types.UPDATE_WHAT_TO_BRING,
      whatToBring: response
    });
  })
  .fail(function(jqXHR, textStatus, errorThrown) {
    utils.renderAjaxErrorModal(jqXHR, textStatus, errorThrown);
  });
}

export function updateItemName(index, value) {
  store.dispatch({
    type: types.UPDATE_ITEM_NAME,
    index,
    value
  });
}

export function updateItemQty(index, value) {
  store.dispatch({
    type: types.UPDATE_ITEM_QTY,
    index,
    value
  });
}

export function addItem() {
  store.dispatch({
    type: types.ADD_ITEM
  });
}

export function removeItem(index) {
  store.dispatch({
    type: types.REMOVE_ITEM,
    index
  });
}

export function toggleEdit() {
  store.dispatch({
    type: types.TOGGLE_EDIT
  })
}

export function toggleAllowOtherItems () {
  store.dispatch({
    type: types.TOGGLE_ALLOW
  })
}

export function selectItem(item, name, quantity) {
  const url = `/ajax/event/${window.evite_event.id}/what-to-bring/select-item/?gid=${window.guest_id}`;
  const data = {
    item,
    name,
    quantity
  };
  window.$.post(url, data, (response) => {
    store.dispatch({
      type: types.UPDATE_WHAT_TO_BRING,
      whatToBring: response
    });
  }).fail(function(jqXHR, textStatus, errorThrown) {
    utils.renderAjaxErrorModal(jqXHR, textStatus, errorThrown);
  });
}

export function removeSelection(id) {
  const url = `/ajax/event/${window.evite_event.id}/what-to-bring/remove-selection/?gid=${window.guest_id}`;
  const data = {
    item: id
  }
  window.$.post(url, data, (response) => {
    store.dispatch({
      type: types.UPDATE_WHAT_TO_BRING,
      whatToBring: response
    });
  })
  .fail(function(jqXHR, textStatus, errorThrown) {
    utils.renderAjaxErrorModal(jqXHR, textStatus, errorThrown);
  });
}

export function deleteWhatToBring() {
  const url = `/ajax/event/${window.evite_event.id}/what-to-bring/?gid=${window.guest_id}`;
  window.$.ajax({
      url: url,
      type: 'DELETE'
  })
  .fail(function(jqXHR, textStatus, errorThrown) {
    utils.renderAjaxErrorModal(jqXHR, textStatus, errorThrown);
  });
  store.dispatch({
    type: types.DELETE_WHAT_TO_BRING
  });
}

export function updateOtherName(index, value)  {
  store.dispatch({
    type: types.UPDATE_OTHER_NAME,
    index,
    value
  })
}

export function updateOtherQty(index, value)  {
  store.dispatch({
    type: types.UPDATE_OTHER_QTY,
    index,
    value
  })
}



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/what-to-bring/actions.es6